import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
    APPLE_PAY,
    CB,
    FORCE_CB_PAYMENT,
    GOOGLE_PAY,
    PAYPAL
} from '../../../constants/paymentMethods';
import { ENTERPRISE_CARD_ENABLED } from '../../../constants/ebon';
import { FUNNEL_PAYMENT_PROCESSING_STEP } from '../../../constants/funnel';

import { createOrder } from '../../../services/ebon/actions';

import Paypal from './payment-choice/Paypal';
import ApplePay from './payment-choice/ApplePay';
import GooglePay from './payment-choice/GooglePay';
import CreditCard from './payment-choice/CreditCard';
import EnterpriseCard from './payment-choice/EnterpriseCard';
import KycMessage from './kyc-message/KycMessage';
import { LoadingComponent } from '../../loading/LoadingComponent';

import './FunnelPaymentSelectionStepStyle.scss';

const FunnelPaymentSelectionStep = ({
    userInfo,
    partnerId,
    setPaymentType,
    cartTotalValue,
    kycNeeded,
    setStateOfTransaction,
    i18n,
    ebonPaymentConfig,
    paymentMethods,
    ebon,
    lock,
    order,
    createOrder
}) => {
    const [selectedMethod, setSelectedMethod] = useState();

    const googlePayAllowed =
        ebonPaymentConfig.googlePayAllowed && paymentMethods.includes(GOOGLE_PAY);
    const applePayAllowed = ebonPaymentConfig.applePayAllowed && paymentMethods.includes(APPLE_PAY);
    const paypalAllowed = ebonPaymentConfig.paypalAllowed && paymentMethods.includes(PAYPAL);

    const handleMethodChange = value => {
        if (selectedMethod !== value) {
            setSelectedMethod(value);
            setPaymentType(value);
        }
    };

    // Create order immediatly on mount if CB payment method is forced
    useEffect(() => {
        if (FORCE_CB_PAYMENT) {
            const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;
            const requestedAmount = null;
            createOrder(partnerId, userInfo.phoneNumber, requestedAmount, !hasFreeFacial);
        }
    }, []);
    // Handle order response
    useEffect(() => {
        if (order.orderState === 'created' && lock.allLocked) {
            setPaymentType(CB);
            setStateOfTransaction(FUNNEL_PAYMENT_PROCESSING_STEP);
            return;
        }
    }, [order]);

    return !FORCE_CB_PAYMENT ? (
        <div id="payment-selection-container">
            <h3 className="title">{`${i18n.PAYMENT_METHOD}`}</h3>

            {kycNeeded && <KycMessage text={i18n.KYC_MESSAGE} />}

            {ENTERPRISE_CARD_ENABLED && (
                <EnterpriseCard
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                    cartTotalValue={cartTotalValue}
                />
            )}

            <CreditCard selectedMethod={selectedMethod} handleMethodChange={handleMethodChange} />

            {paypalAllowed && (
                <Paypal selectedMethod={selectedMethod} handleMethodChange={handleMethodChange} />
            )}

            {googlePayAllowed && (
                <GooglePay
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                />
            )}

            {applePayAllowed && (
                <ApplePay selectedMethod={selectedMethod} handleMethodChange={handleMethodChange} />
            )}
        </div>
    ) : (
        <div id="payment-selection-container">
            <LoadingComponent />
        </div>
    );
};

FunnelPaymentSelectionStep.propTypes = {
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    cartTotalValue: PropTypes.number,
    kycNeeded: PropTypes.bool,
    setStateOfTransaction: PropTypes.func
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        ebonPaymentConfig: state.ebon.ebons.ebonPaymentConfig,
        paymentMethods: state.ebon.lock[0].paymentMethods || [],
        ebon: state.ebon,
        lock: state.ebon.lock,
        order: state.ebon.createdOrder
    };
};

const mapDispatchToProps = {
    createOrder
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FunnelPaymentSelectionStep));



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/FunnelPaymentSelectionStep.js